import { Box, Button, Card, CardContent, CardHeader, Checkbox, Divider, FormControlLabel, FormGroup, Grid, TextField, Typography, Dialog, DialogContent, DialogTitle, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { UUID } from '../../helpers/uuid'
import { FormChildrenType } from '../../state/constants/FormConstants'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles({
    //Both
    root: {
        width: "100%"
    },
    cardHeader: {
        padding: "8px",
        paddingBottom: "0px"
    },
    cardContent: {
        padding: "8px",
        '&:last-child': {
            paddingBottom: "8px",
        }
    },
    expansionDetails: {
        padding: "8px"
    },
    deleteButton: {
        float: "right",
        marginTop: "8px",
        marginBottom: "8px"
    },
    // Form Group
    cardHeaderAction: {
        margin: "0px"
    },

})

function FormGroupCard(props) {

    const classes = useStyles()
    const [t, i18n] = useTranslation()

    // const [formGroup, setFormGroup] = useState(props.formGroup)
    const formGroup = props.formGroup
    const setFormGroup = props.setFormGroup

    const [addChildModalOpen, setAddChildModalOpen] = useState(false)

    function handleCheckboxChange(id, source, value) {
        const updatedFormGroup = Object.assign({}, formGroup)

        switch (source) {
            case "Dynamic":
                updatedFormGroup.Dynamic = value
                break
            case "Sticky":
                updatedFormGroup.IsSticky = value
                break
            default:
                break
        }

        setFormGroup(updatedFormGroup)
    }

    function handleNameChange(value) {

        const updatedFormGroup = Object.assign({}, formGroup)
        updatedFormGroup.Name = value
        setFormGroup(updatedFormGroup)
    }

    function handleAddChild(type) {
        const updatedFormGroup = Object.assign({}, formGroup)
        setFormGroup(updatedFormGroup, [type])
    }

    function addChildModal() {
        return (
            <Dialog open={addChildModalOpen}>
                <DialogTitle>
                    {t('form.add')}
                </DialogTitle>
                <DialogContent>
                    <Button onClick={() => {
                        setAddChildModalOpen(false)
                        handleAddChild(FormChildrenType().QUESTION.key)
                    }}>
                        {t('form.question')}
                    </Button>
                    <Button onClick={() => {
                        setAddChildModalOpen(false)
                        handleAddChild(FormChildrenType().FORM_GROUP.key)
                    }}>
                        {t('form.header')}
                    </Button>
                </DialogContent>
            </Dialog>
        )
    }

    function wrapContent(id, name, content) {
        return (
            <ExpansionPanel defaultExpanded onChange={(event) => console.log(event)}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    <Grid container>
                        <Grid item xs={10}>
                            <TextField
                                fullWidth
                                aria-label="FormGroupTitleTextField"
                                value={formGroup.Name}
                                label={t('form.header-name')}
                                onChange={(event) => {
                                    event.stopPropagation()
                                    handleNameChange(event.target.value)
                                }}
                                onClick={(event) => event.stopPropagation()}
                                variant="outlined"
                                margin="dense"
                                disabled={props.disabled}
                                onFocus={(event) => {
                                    event.stopPropagation()
                                }}
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <Button
                                className={classes.deleteButton}
                                aria-label="Delete"
                                variant="outlined"
                                margin="dense"
                                onClick={props.handleDelete}
                                color="primary"
                                onFocus={(event) => event.stopPropagation()}
                            >
                                {t('common.delete')}
                            </Button>
                        </Grid>

                    </Grid>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansionDetails}>
                    {content}
                </ExpansionPanelDetails>
            </ExpansionPanel>
        )
    }

    return (
        wrapContent(formGroup.id, formGroup.Name,
            < Box className={classes.root} >
                {addChildModal()}
                < Card elevation={0} >
                    <CardHeader
                        classes={{
                            root: classes.cardHeader,
                            action: classes.cardHeaderAction
                        }}
                        subheader={formGroup.subtitle}
                    //// TODO: Uncomment when InfluencesOutcomes are implemented
                    // action={
                    //     <FormGroup row>
                    //         <FormControlLabel
                    //             control={
                    //                 <Checkbox
                    //                     checked={formGroup.Dynamic}
                    //                     onChange={(event) => handleCheckboxChange(formGroup.id, "Dynamic", event.target.checked)}
                    //                     name="checkedDynamic"
                    //                     disabled={props.disabled}
                    //                 />
                    //             }
                    //             label="Dynamic"
                    //         />
                    //         <FormControlLabel
                    //             control={
                    //                 <Checkbox
                    //                     checked={formGroup.IsSticky}
                    //                     onChange={(event) => handleCheckboxChange(formGroup.id, "Sticky", event.target.checked)}
                    //                     name="checkedSticky"
                    //                     disabled={props.disabled}
                    //                 />
                    //             }
                    //             label="Sticky"
                    //         />
                    //     </FormGroup>
                    // }
                    />
                    <CardHeader
                        classes={{
                            root: classes.cardHeader,
                            action: classes.cardHeaderAction
                        }}
                        subheader={formGroup.subtitle}
                        action={

                            <Button
                                variant="outlined"
                                onClick={() => setAddChildModalOpen(true)}
                                disabled={props.disabled}
                            >
                                {t('form.add-item')}
                        </Button>
                        }
                    />
                    <CardContent
                        className={classes.cardContent}
                    >

                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container spacing={1}>
                                    {formGroup.FormGroupChildren == null ?
                                        null :
                                        formGroup.FormGroupChildren.map(item => (
                                            <Grid item xs={12}>
                                                {props.typeSwitch(item.id)}
                                            </Grid>
                                        ))}
                                </Grid>
                            </Grid>
                        </Grid>


                    </CardContent>
                </Card >
            </Box >
        )
    )
}

FormGroupCard.propTypes = {
    formGroup: PropTypes.shape({
        Dynamic: PropTypes.bool,
        IsSticky: PropTypes.bool,
        Name: PropTypes.string,
        FormGroupChildren: PropTypes.arrayOf(PropTypes.node),
        id: PropTypes.string
    }),
    typeSwitch: PropTypes.func.isRequired,
    setFormGroup: PropTypes.func.isRequired,
    handleDelete: PropTypes.func.isRequired
}

export default React.memo(FormGroupCard)

